var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsInvest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9304_97715)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.70986 4.74097L7.42414 1.40763C7.77998 1.20006 8.22001 1.20006 8.57585 1.40763L14.2902 4.74097C14.6413 4.94578 14.8571 5.32166 14.8571 5.72814V11.2724C14.8571 11.6789 14.6413 12.0548 14.2902 12.2596L8.57585 15.593C8.22001 15.8005 7.77998 15.8005 7.42414 15.593L1.70986 12.2596C1.35875 12.0548 1.14285 11.6789 1.14285 11.2724V5.72814C1.14285 5.32166 1.35875 4.94578 1.70986 4.74097Z",
    stroke: "#EBE9EF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.14285 8.49972C5.14285 9.25748 5.44387 9.98421 5.97969 10.52C6.51551 11.0558 7.24223 11.3569 8 11.3569C8.75776 11.3569 9.48448 11.0558 10.0203 10.52C10.5561 9.98421 10.8571 9.25748 10.8571 8.49972C10.8571 7.74196 10.5561 7.01523 10.0203 6.47942C9.48448 5.9436 8.75776 5.64258 8 5.64258C7.24223 5.64258 6.51551 5.9436 5.97969 6.47942C5.44387 7.01523 5.14285 7.74196 5.14285 8.49972Z",
    stroke: "#EBE9EF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9304_97715"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsInvest);
export default __webpack_public_path__ + "static/media/settings-invest.f6cdf990d7bbd4fabdcfe2d1b0ea7ed3.svg";
export { ForwardRef as ReactComponent };